import { ActiveLanguage } from 'shared/vidio_helpers';
import Blocker from 'components/shared/Blocker';
import { LocationMediator } from 'shared/vidio_helpers';
import PhoneVerificationModal from 'shared/components/phone_verification_modal';

export default class VerifyPhoneNumber {
  constructor(element, currentUser) {
    this.element = element;
    this.currentUser = currentUser;
  }

  type() {
    return 'verify_phone_number';
  }

  show() {
    let currentPage = new URL(window.location.href);
    currentPage.searchParams.set('t', window.contentGatingActionRequiredAfter);
    currentPage.searchParams.set('gating_action', this.type());
    let returnLink = encodeURIComponent(currentPage.pathname+currentPage.search);

    let lang = ActiveLanguage.get();
    let title = window.Locale[lang].content_gating_banner.verify_phone_number.title;
    let subtitle = window.Locale[lang].content_gating_banner.verify_phone_number.subtitle;
    let buttonText = window.Locale[lang].content_gating_banner.verify_phone_number.button;

    let button = {
      text: buttonText,
      align: 'horizontal',
      theme: 'red'
    }
    if(!this.currentUser) {
      let link = `/users/login?user_return_to=${returnLink}&onboarding_source=verify_phone_number_blocker`
      button = Object.assign({}, button, {link: link});
    } else {
      this.createPhoneVerificationModal();
      button = Object.assign({}, button, {callback: this.showPhoneVerificationModal.bind(this)});
      if (LocationMediator.href().indexOf(`gating_action=${this.type()}`) > -1) {
        this.showPhoneVerificationModal();
      }
    }
    let buttons = [button]

    let blocker = new Blocker({element: this.element, title, subtitle, buttons});
    blocker.show();

    this.element.classList.remove('hide');
  }

  createPhoneVerificationModal() {
    this.currentPhoneVerificationModal = new PhoneVerificationModal({
      onSuccessSectionModalClosed: () => {
        window.location.reload();
      }
    });
    this.currentPhoneVerificationModal.init();
  }

  showPhoneVerificationModal() {
    this.currentPhoneVerificationModal.openModal();
  }
}